import { Api } from '../../Api';
import { BaseStatApi } from './categories/BaseStatApi';
// import { StatLogsApi } from './categories/StatLogsApi';

export class StatApi {

	// logs: StatLogsApi;
	baseStat: BaseStatApi;

	constructor(api: typeof Api) {
		// this.logs = new StatLogsApi(api);
		this.baseStat = new BaseStatApi(api);
	}

}
